<template>
  <div class="blog-wrapper">
    <blog-header/>
    <div class="subpage__inner">
      <SubpageNav2 :links="links" class="DesktopTab"/>
      <div class="mobileTab">
        <!-- <select-box :options="links" title="Girişimcilik"/> -->
        <v-select placeholder="Kategori Seçiniz" :options="links" @onselect="selectCategory"/>
      </div>
      <!--
      <container>
        <div v-if="blogs" class="blog-list col-xl-10 offset-xl-1">
     
          <div v-if="blogs.length > 0">
            <div class="blog-list__item" v-for="blog in blogs" :key="blog.id">
              <blog-card :blog="blog"/>
            </div>
          </div>
          <div class="blog-list__bottom">
            <v-button
              class="button--stroke round"
              title="Daha Fazla"
            />
          </div>
          <Advert />
        </div>
      </container> -->

      <container>
        <ContentLoader v-if="!blogs">
        <rect x="39" y="0" rx="3" ry="3" width="104" height="110" />
        <rect x="149" y="0" rx="3" ry="3" width="104" height="110" />
        <rect x="258" y="0" rx="3" ry="3" width="102" height="110" />
        
        <rect x="39" y="115" rx="3" ry="3" width="104" height="110" />
        <rect x="149" y="115" rx="3" ry="3" width="104" height="110" />
        <rect x="258" y="115" rx="3" ry="3" width="102" height="110" />      
      </ContentLoader>  
<!--           <div class="result-bracket__title">
            <span class="result-bracket__count" v-if="blogs.length > 0">{{ blogs.length }}</span> <span v-if="filteredBlogs.length > 0">Adet Bulundu!</span>
            <empty-content :content="emptyContent" v-if="blogs.length === 0"/>
          </div> -->
                  
          <div class="text-center mb-35 mt-35">
            <div class="result-bracket__title">
              <span class="result-bracket__count" v-if="blogs.length > 0">{{ blogs.length }}</span> İçerik Bulunuyor!
            </div>
          </div>

            <!-- <div class="text-center mb-35">
              <div class="result-bracket__title">
                <span class="result-bracket__count mycenter" v-if="blogs.length > 0">{{ blogs.length }} İçerik Bulunuyor</span> 
                <span v-if="filteredBlogs.length > 0"></span> 
              </div>          
            </div>  -->
        <div class="blog-list col-xl-10 offset-xl-1">
<!--           <div class="result-bracket__title">
            <span class="result-bracket__count">{{ blogs.length }}</span> Adet Bulundu!
          </div> -->
      
          <div class="blog-list__item" v-for="blog in blogs" :key="blog.id">
            <blog-card :blog="blog"/>
          </div>
<!--           <div class="blog-list__bottom">
            <v-button
              class="button--stroke round"
              title="Daha Fazla"
            />
          </div>
          <Advert/>
          <AdvertBanner class="banner-mobile"/> -->
        </div>
      </container>

    </div>
  </div>
</template>

<script>
import BlogHeader from '@/components/Blog/BlogHeader'
import BlogCard from '@/components/Blog/BlogCard'
import SubpageNav2 from '@/components/SubpageNav2'
import Advert from '@/components/Advert'
import SelectBox from '@/components/SelectBox'
import axios from 'axios'
import EmptyContent from '@/components/EmptyContent'
import { ContentLoader } from 'vue-content-loader'
import { SET_BLOG_CATEGORY_TITLE, SET_BLOG_CATEGORY_SLUG } from '@/store/mutations.type'
//import { mapGetters } from 'vuex'
export default {
  name: 'Blog',
  components: {
    BlogHeader, SubpageNav2, BlogCard, Advert, SelectBox, EmptyContent, ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Blog' + ' | ' + this.opt.value,
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/blog/' + this.opt.value }
      ] 
    }
  },  
  data () {
    return {
      opt: {value:''},
      typeID: 1,
      links: [],
      blogs: [],
      filteredBlogs: [],
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }      
    }
  },
  methods: {
    selectCategory(opt) {
      this.opt = opt
      store.commit(SET_BLOG_CATEGORY_TITLE, opt.value )
      this.$router.push('/blog/kategori/' + opt.value)
      window.localStorage.setItem('category', opt.value)
    },    
    getBLogs () {
      let self = this
      //  axios.get(`/site/blogs/category/${this.$route.params.slug}`)
      const blogCategory = window.localStorage.getItem('blogCategory')
      axios.get(`/site/blogs/category/${blogCategory}`)

        .then(response => {
          self.blogs = response.data.blogs 
        })
        .catch(e => {
          this.errors.push(e)
        })
       

    },

    getCategories () {
      let self = this
      axios.get(`/site/blogs/category/list`)
        .then(response => {
          self.categories = response.data
          self.links = self.categories.map((item) => {
            return {
              id: item.id,
              title: item.title,
              name: item.title,
              value: item.slug,
              to: { name: 'BlogCategory', params: { slug: item.slug } }
            }
          })
 
        })
        .catch(e => {
          this.errors.push(e)
        })
    }   
  },
  created () {
    this.getBLogs()
    this.getCategories()
  },
  watch: {
    $route () {
     this.getBLogs () 
    }
  },
/*   computed: {
    ...mapGetters(['blogCategory'])
  } */
}
</script>

<style lang="scss">
  @import "../assets/scss/components/blog";
  .mycenter {
    display:table;
    margin:0 auto;
  }
</style>
